import { useAlert } from "hooks/alerts/useAlert";
import useOnboarding from "hooks/companySettings/useOnboarding";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "services/api.service";
import { Location } from "types/location";

export default function useUpdateLocation(originalPath: string) {
  const { fetchOnboarding } = useOnboarding();
  const navigate = useNavigate();
  const { alertError } = useAlert();

  const updateLocation = useCallback(
    ({ uuid, organization, ...location }: Location) =>
      api
        .put<Location>(`/locations/${uuid}`, { location })
        .then((res) => {
          if (originalPath) {
            navigate(originalPath, { state: { location: res.data } });
          } else {
            navigate("/company-settings/locations");
          }
        })
        .catch(({ response: { data } }) => {
          if (data.errors.contact[0].email) {
            alertError(data.errors.contact[0].email);
          } else {
            alertError(data.errors.toString());
          }
        })
        .finally(() => {
          fetchOnboarding && fetchOnboarding();
        }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return {
    updateLocation,
  };
}
